/*=========================================================================================
  File Name: module-usertax-mutations.js
  Description: UserTax Module Mutations
  ----------------------------------------------------------------------------------------
  Project: MISA MTAX WebApp
  Author: MISA JSC
  Author URL: http://www.misa.com.vn
==========================================================================================*/
/**
 * state mặc định của module
 */
import { MSEnum } from '@/common/enumeration';
import msDateUtil from '@/components/msdatepicker/msDateUtil';

import defaultState from './module-outinvoice-state';

export default {
	resetState(state) {
		Object.assign(state, defaultState);
	},
	updateOutInvoices(state, res) {
		let result = res.data;
		state.OutInvoices = result.Data || [];
		if (res.isGetTotal) {
			// API có lấy ds hóa đơn có lấy thông tin tổng hóa đơn
			state.OutInvoicesTotal = result.Total;
		} else if (result.Total) {
			state.OutInvoicesTotal = result.Total ? result.Total : state.OutInvoicesTotal;
		}
	},
	updateLoadingTotalRecords(state, res) {
		state.IsLoadingTotalRecords = res;
	},

	updateTotalPage(state, res) {
		state.OutInvoicesTotal = res || 0;
	}
};
